import { useEffect, useState } from 'react'
import styles from './CompanyPage.module.css'
import Navbar from '../../components/Navbar/Navbar'

import { useNavigate, useParams } from 'react-router-dom'
import { useAppDispatch, useAppSelector } from '../../redux/types/types'

import PATH from '../../navigation/path'
import Loader from '../../components/UI/Loader/Loader'
import {
  deleteCurrentFileFromCompany,
  getCurrentCompany,
  pushNewFilesToCompany,
} from '../../redux/actions/companiesAction'

import EventsList from '../../components/EventsList/EventsList'
import { placesPerPage } from '../../constants/constants'
import { PlaceType } from '../../redux/actions/types'
import { EventType } from '../MainPage/MainPage'
import { getPlacesFromCompany } from '../../redux/actions/placesAction'

import CustomModal from '../../components/UI/CustomModal/CustomModal'

import HeaderForCard from '../../components/HeaderForCard/HeaderForCard'
import CompanyTabs from '../../components/CompanyTabs/CompanyTabs'
import EditCompanyShortInformation from '../../components/EditCompanyShortInformation/EditCompanyShortInformation'
import EditCompanyLegalInformation from '../../components/EditCompanyLegalInformation/EditCompanyLegalInformation'
import ImagesEdit from '../../components/ImagesEdit/ImagesEdit'
import CustomButton from '../../components/UI/CustomButton/CustomButton'
import CreatePlatform from '../../components/CreatePlatform/CreatePlatform'
import { useToast } from '../../context/ToastContext'

const CompanyPage = () => {
  const [modal, setModal] = useState(false)
  const [currentPage, setCurrentPage] = useState(1)
  const [activeTab, setActiveTab] = useState(1)

  const { companyId } = useParams<{ companyId: string }>()

  const navigate = useNavigate()

  let { userRole, user, token } = useAppSelector((state) => state.auth)
  const { currentCompany } = useAppSelector((state) => state.companies)
  const { isLoading, places } = useAppSelector((state) => state.places)

  const dispatch = useAppDispatch()

  const { showSuccess, showError } = useToast()

  const dummyDataEvents = (array: PlaceType[]) => {
    const items: EventType[] = array.map((place) => {
      return {
        id: place.id,
        title: place.name,
        subTitle: place.company.name,
        numberOfPerson: String(place.size),
        images: place.images.map((p, index) => {
          return { id: index, src: `${process.env.REACT_APP_BASE_URL_IMAGES}${p}` }
        }),
      }
    })
    return items
  }

  const onUploadNewImages = async (photosFile: any, setPhotos: any) => {
    const formData = new FormData()

    if (photosFile.length !== 0) {
      for (let i = 0; i < photosFile.length; i++) {
        formData.append('images', photosFile[i])
      }

      const resultAction = await dispatch(
        pushNewFilesToCompany({ companyId: String(currentCompany.id), formData, token }),
      )

      if (pushNewFilesToCompany.rejected.match(resultAction)) {
        showError(
          'Произошла ошибка при загрузке, возможно вы загрузили слишком много файлов, нельзя загружать больше 10.',
        )
      } else {
        await dispatch(getCurrentCompany({ companyId, token }))
        setPhotos([])
      }
    }
  }

  const onDeleteImageFromServer = async (image: string) => {
    const resultAction = await dispatch(
      deleteCurrentFileFromCompany({
        token,
        companyId: String(currentCompany.id),
        filesToDelete: [image],
      }),
    )

    if (deleteCurrentFileFromCompany.rejected.match(resultAction)) {
      showError('Произошла ошибка при удалении файла')
    } else {
      await dispatch(getCurrentCompany({ companyId, token }))
    }
  }

  const eventList = dummyDataEvents(places.places)

  const dummyData = (imagesArr: string[]) => {
    return imagesArr.map((image, index) => {
      return { id: index, src: `${process.env.REACT_APP_BASE_URL_IMAGES}${image}` }
    })
  }

  const imagesFull = dummyData(currentCompany?.images)

  const onRedirectBack = () => {
    navigate(-1)
  }

  const onRedirectToEditCardPage = () => {
    navigate(`${PATH.editCompanyPage}${companyId}`)
  }

  const onRedirectToCreatePlatform = () => {
    navigate(PATH.createPlatformPage)
  }

  const foundObject = currentCompany.employees.find((item) => item.id === user.employee?.id)

  useEffect(() => {
    dispatch(getCurrentCompany({ companyId, token }))
  }, [companyId, dispatch])

  useEffect(() => {
    dispatch(
      getPlacesFromCompany({
        token,
        page: currentPage,
        itemsPerPage: placesPerPage,
        companyId: companyId,
      }),
    )
  }, [dispatch, currentPage, setCurrentPage, placesPerPage])

  if (isLoading) {
    return <Loader />
  }

  return (
    <div className={styles.companyPage}>
      <Navbar />
      {/* <button onClick={onRedirectToEditCardPage}>434</button> */}
      <HeaderForCard onRedirectHandler={onRedirectBack} title={currentCompany.name} />
      <CompanyTabs activeTab={activeTab} setActiveTab={setActiveTab} />

      {activeTab === 1 ? (
        <div className={styles.container}>
          <ImagesEdit
            onDeleteImageFromServer={onDeleteImageFromServer}
            currentObjectImages={currentCompany.images}
            onUploadNewImages={onUploadNewImages}
            imagesFull={imagesFull}
          />
          <div className={styles.content}>
            <EditCompanyShortInformation
              address={currentCompany.address}
              city={currentCompany.city}
              companyId={currentCompany.id}
              description={currentCompany.description}
              email={currentCompany.email}
              phone={currentCompany.contactPhone}
              key={currentCompany.id}
            />
            <EditCompanyLegalInformation
              companyId={currentCompany.id}
              companyName={currentCompany.name}
              inn={currentCompany.inn}
              role={currentCompany.role}
              contactFullName={currentCompany.contactFullName}
              contactPhone={currentCompany.contactPhone}
              email={currentCompany.email}
            />
          </div>
        </div>
      ) : (
        <div className={styles.containerPlatforms}>
          <div className={styles.platformContent}>
            <div className={styles.platformTitleBlock}>
              {userRole !== 'employeeAgent' &&
                userRole !== 'employeePlace' &&
                userRole !== 'directorAgent' && (
                  <CustomButton
                    className={styles.addSiteBtn}
                    title='Создать зал'
                    type='button'
                    onClick={() => setModal(true)}
                  />
                )}
            </div>
            <div className={styles.eventList}>
              {eventList.length !== 0 ? (
                <EventsList
                  eventList={eventList}
                  pageSize={placesPerPage}
                  fromMainPage
                  currentPage={currentPage}
                  setCurrentPage={setCurrentPage}
                  totalCountPages={places.totalCount}
                />
              ) : (
                <div style={{ width: '100%', textAlign: 'center' }}>Список залов пуст...</div>
              )}
            </div>
          </div>
        </div>
      )}
      <CustomModal visible={modal} setVisible={setModal}>
        <CreatePlatform onClickHandler={() => setModal(false)} />
      </CustomModal>
      {/* <Footer /> */}
    </div>
  )
}

export default CompanyPage
